import '../../../assets/css/NewCAP.css';
import '../../../App.css';
import { useEffect, useState } from 'react';
import LoadingSpinner from '../../../utils/LoadingSpinner';
import { createIncident, getLocationData } from '../../../utils/AWSAPI';
import { serializeFile, submitAttachments } from '../../../utils/Utils';
import { useTranslation } from 'react-i18next';
import i18n from "../../Translations/i18n/i18n";  //import i18next
import { validateFilesSnow, isHeicLike, fileToJpegName, ensureJpegIfHeic } from '../../../utils/FileHelper';
import { BiSolidError, BiSolidCheckCircle } from "react-icons/bi";
import { ClipLoader } from "react-spinners";
function NewCAP() {
  const [relatedToPrinter, setRelatedToPrinter] = useState(false);

  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [isSubmitting, setSubmitting] = useState(false);
  const [data, setData] = useState(null);


  // Are we showing a modal? I.E: Error, success.
  const [isModalShowing, setModalShowing] = useState(false);
  const [isModalUncloseable, setModalUncloseable] = useState(false);

  //Files status 
  const [attachment1DisplayName, setAttachment1DisplayName] = useState("");
  const [attachment2DisplayName, setAttachment2DisplayName] = useState("");
  const [attachment1File, setAttachment1File] = useState(null);
  const [attachment2File, setAttachment2File] = useState(null);
  const [file1State, setFile1State] = useState({ isConverting: false });
  const [file2State, setFile2State] = useState({ isConverting: false });

  const [file1Validation, setFile1Validation] = useState({
    status: "idle", // "idle" | "loading" | "success" | "failure"
    message: ""
  });

  const [file2Validation, setFile2Validation] = useState({
    status: "idle",
    message: ""
  });

  const [modalHeader, setModalHeader] = useState('Loading...');
  const [modalBody, setModalBody] = useState(<></>);
  const [modalFooter, setModalFooter] = useState(<></>);

  const closeModal = () => {
    setModalShowing(false);
  };

  const Modal = () => {
    return (
      <form>
        <div className="modal show">
          <div className="modal-content">
            <div className="modal-header">
              <h4>{modalHeader}</h4>
              {!isModalUncloseable && (
                <span className="close" onClick={closeModal}>&times;</span>
              )}
            </div>
            <div className="modal-body">{modalBody}</div>
            <div className="modal-footer">{modalFooter}</div>
          </div>
        </div>
      </form>
    );
  };

  const updateModal = (header, body, footer) => {
    setModalShowing(!isModalShowing);
    setModalHeader(header);
    setModalBody(body);
    setModalFooter(footer);
  }

  const { t } = useTranslation();

  const setDefaultAttributes = async () => {
    const url = new URL(window.location.href);
    const locationValue = url.searchParams.get('location');

    if (!locationValue) {
      updateModal(t('error_modal_header'), t('error_no_location_selected'))
      return { success: false };
    } else {
      return { success: true, location: locationValue };
    }
  }
  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { success, location: fetchedLocation, locationName: fetchedName } = await setDefaultAttributes();
        if (success) {
          const locationData = await getLocationData(fetchedLocation);

          if (locationData.Error) {
            return updateModal(t('error_modal_header'), locationData.Error)
          } else {
            setData(locationData);
            setLoading(false);
          }
        } else {
          console.log("Invalid location. Not calling API.");
        }
      } catch (err) {
        console.log(err);
      }
    };
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);


  const getSelectedAttachmentsFromState = () => {
    return [attachment1File, attachment2File].filter(Boolean);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!attachment1File || !attachment2File) {
      updateModal(t("error_modal_header"), t("Please select both attachments."));
      return;
    }


    if (file1Validation.status !== "success" || file2Validation.status !== "success") {
      updateModal(
        t("error_modal_header"),
        t("Please ensure both attachments are valid before submitting.")
      );
      return;
    }

    setSubmitting(true);
    submitCAPRequest(event);
  };

  const getFullDescription = async () => {
    var fields = []
    fields.push("CAP Subject: " + (relatedToPrinter ? "Printer" : "Bump-Bar") + "\n")
    if (relatedToPrinter) {
      fields.push("Printer Model: " + document.getElementById("printerModel").value + "\n")
    }
    fields.push("Location: " + document.getElementById("equipmentLocation").value + "\n")
    fields.push("Equipment Details: " + document.getElementById("equipmentDetails").value + "\n")
    fields.push("\n" + document.getElementById("info").value)
    return fields.join("");
  }
  const normalizeKey = (value) =>
    value
      .toLowerCase()
      .replace(/[\(\)]/g, "")
      .replace(/[\s\/-]+/g, "_")
      .replace(/_+$/, "");
  const getCapCategoryAndSubcategory = () => {
    const categoryLabel = "POS (Sesame)";

    if (!relatedToPrinter) {
      // Bump-Bar: siempre el mismo subcategory
      const subcategoryLabel = "KVS Bump Bar";
      return {
        category: normalizeKey(categoryLabel),       // pos_sesame
        subcategory: normalizeKey(subcategoryLabel), // kvs_bump_bar
        categoryLabel,
        subcategoryLabel,
      };
    }

    const location = document.getElementById("equipmentLocation")?.value;

    const subcategoryLabelByLocation = {
      "Front Counter": "POS FC Printer",
      "Drive Thru": "POS DT Printer",
      "KVS": "KVS Grill Printer",
    };

    const subcategoryLabel = subcategoryLabelByLocation[location] || "";

    return {
      category: normalizeKey(categoryLabel),
      subcategory: normalizeKey(subcategoryLabel),
      categoryLabel,
      subcategoryLabel,
    };
  };


  const submitCAPRequest = async (event) => {
    try {
      if (data.CallerEmail == null) {
        updateModal("Error", "This restaurant doesn't seem to be entirely setup. Please ask your administrator for assistance.");
        return;
      }


      setSubmitting(true);
      await getFullDescription().then(async description => {
        const { category, subcategory } = getCapCategoryAndSubcategory();

        const incident = await createIncident(
          "",
          category,       // pos_sesame
          subcategory,    // kvs_bump_bar / pos_fc_printer / pos_dt_printer / kvs_grill_printer
          data.CallerEmail,
          data.Name,
          document.getElementById('nname').value || "Unspecified",
          "4",
          "4",
          "Self Service CAP Request",
          description
        );

        if (incident.Error) {
          console.log(incident.Error);
          return;
        }

        const form = event.target;
        const formData = new FormData(form);

        const sysId = incident.SysID;
        const caseNumber = incident.Result;

        console.log("CAP Request submitted. Uploading attachments one by one...");

        setModalUncloseable(true);

        const uploadResults = [];

        if (attachment1File) {
          try {
            const [serialized] = (await Promise.all([serializeFile(attachment1File)])).filter(Boolean);
            const res1 = await submitAttachments(sysId, serialized ? [serialized] : []);
            uploadResults.push({
              which: 1,
              name: attachment1File.name,
              ok: !res1?.Error,
              details: res1?.Detail || res1?.Message || res1?.Error || ""
            });
          } catch (e) {
            uploadResults.push({
              which: 1,
              name: attachment1File.name,
              ok: false,
              details: e?.message || "Upload failed."
            });
          }
        }

        if (attachment2File) {
          try {
            const [serialized] = (await Promise.all([serializeFile(attachment2File)])).filter(Boolean);
            const res2 = await submitAttachments(sysId, serialized ? [serialized] : []);
            uploadResults.push({
              which: 2,
              name: attachment2File.name,
              ok: !res2?.Error,
              details: res2?.Detail || res2?.Message || res2?.Error || ""
            });
          } catch (e) {
            uploadResults.push({
              which: 2,
              name: attachment2File.name,
              ok: false,
              details: e?.message || "Upload failed."
            });
          }
        }

        const failedUploads = uploadResults.filter(r => !r.ok);

        let modalText =
          "CAP Request submitted successfully. Incident Number: " +
          incident.Result +
          ".\n\n";

        if (failedUploads.length > 0) {
          modalText += "Attachments:\n";
          modalText += uploadResults
            .map(r => {
              if (r.ok) return ` ${r.name}: uploaded`;
              return ` ${r.name}: failed (${r.details || "Unknown error"})`;
            })
            .join("\n");
          modalText += "\n\nPlease wait...";
        } else {
          modalText += "Attachments uploaded successfully.\n\nPlease wait...";
        }

        updateModal("Success", modalText);

        setSubmitting(false);

        const redirectDelayMs = failedUploads.length > 0 ? 10000 : 1000;

        setTimeout(() => {
          window.location.href = `incident?ticketNumber=${caseNumber}`;
        }, redirectDelayMs);

      });
    } catch (err) {
      console.log(err);
    }
  }

  const getSelectedAttachments = () => {
    const a1 = document.getElementById("attachment1")?.files?.[0] || null;
    const a2 = document.getElementById("attachment2")?.files?.[0] || null;
    return [a1, a2].filter(Boolean);
  };
  const onAttachmentChange = (which) => async (e) => {
    const rawFile = e.target.files?.[0] || null;

    const isFirst = which === 1;
    const setFileState = isFirst ? setFile1State : setFile2State;
    const setDisplayName = isFirst ? setAttachment1DisplayName : setAttachment2DisplayName;
    const setFile = isFirst ? setAttachment1File : setAttachment2File;
    const setValidation = isFirst ? setFile1Validation : setFile2Validation;

    // Reset per-file UI state
    setFileState({ isConverting: false });

    if (!rawFile) {
      setFile(null);
      setDisplayName("");
      setValidation({ status: "idle", message: "" });
      return;
    }

    try {
      const heic = isHeicLike(rawFile);

      if (heic) setFileState({ isConverting: true });

      const finalFile = await ensureJpegIfHeic(rawFile);

      if (heic) setFileState({ isConverting: false });

      setFile(finalFile);
      setDisplayName(finalFile?.name || "");

      // Validate ONLY this file
      await validateSingleAttachmentSnow(finalFile, which);
    } catch (err) {
      console.error("Attachment process error:", err);

      setFileState({ isConverting: false });
      setDisplayName("");
      setFile(null);

      // Better message for the rename/corrupt case
      if (err?.message?.includes("Image is already browser readable")) {
        setValidation({
          status: "failure",
          message:
            "The file content doesn’t match its extension. It may have been renamed or corrupted. Please upload a valid file."
        });
        return;
      }

      let errorMessage = "Failed to process attachment.";
      if (err?.message) errorMessage = err.message;
      else if (typeof err === "string") errorMessage = err;

      setValidation({ status: "failure", message: errorMessage });
    }
  };

  const validateSingleAttachmentSnow = async (file, which) => {
    const setValidation = which === 1 ? setFile1Validation : setFile2Validation;

    if (!file) {
      setValidation({ status: "idle", message: "" });
      return;
    }

    setValidation({ status: "loading", message: "" });

    try {
      const res = await validateFilesSnow([file]);
      const results = res?.Result?.result || [];

      if (!Array.isArray(results) || results.length === 0) {
        setValidation({ status: "failure", message: "Validation failed: empty response." });
        return;
      }

      const r = results[0];
      if (r?.Status === "Success") {
        setValidation({ status: "success", message: "" });
        return;
      }

      setValidation({
        status: "failure",
        message: r?.Message || "Invalid file."
      });
    } catch (e) {
      setValidation({ status: "failure", message: "Validation request failed." });
    }
  };

  const canSubmitAttachments = () => {
    const bothSelected = Boolean(attachment1File) && Boolean(attachment2File);
    const bothValidated =
      file1Validation.status === "success" && file2Validation.status === "success";

    return bothSelected && bothValidated;
  };


  return (
    <div className="App">
      <LoadingSpinner show={isLoading || isSubmitting} />

      {isModalShowing && (
        <Modal />
      )}

      {data && (
        <form onSubmit={handleSubmit}>
          <div className="new-cap-container">
            <div className="recuadro">
              <h1>
                {t('submit_cap_request')}
              </h1>
              <hr />
              <br />
              <b>
                <span style={{ color: 'red' }}>{t('please_note')}:</span>
                <br /><br />
                {t('automated_submission_info')} <span style={{ color: 'red' }}>{t('printers')} </span>{t('and')} <span style={{ color: 'red' }}>{t('bumpbars')} </span>{t('forcases')}<span style={{ color: 'red' }}> {t('obviousfailure')}</span>, {t('photosdemostrating')} <span style={{ color: 'red' }}>{t('required')} </span>{t('completesubmission')}<a href='google.com'>link</a>{t('moreinfo')}
                <br /><br />
                * {t('replacement_info')}
                <br /><br />
                {t('aten_adapter_info')}
              </b>
              <br /><br />
            </div>

            <div className="recuadro" >
              <label htmlFor="fname" className="required">{t('restaurant')}:</label>
              <input type="text" id="fname" name="fname" disabled placeholder={data.Name} value={data.Name} required />
              <br /><br />
              <label htmlFor="lname" className="required">{t('store_phone_number')}: </label>
              <input type="text" id="lname" name="lname" disabled placeholder={data.Phone} value={data.Phone} required />
              <br /><br />
              <label htmlFor="nname">{t('preferred_callback_number')}: </label>
              <input type="text" id="nname" name="nname" />
              <br /><br />

              <hr />
              <br />

              <div className="radio-option">
                <input type="radio" id="bumpBar" name="device" value="Bump-Bar" checked={!relatedToPrinter} onChange={() => setRelatedToPrinter(false)} />
                <label htmlFor="bumpBar">{t('bump_bar')}</label>
              </div>


              <div className="radio-option">
                <input type="radio" id="printer" name="device" value="Printer" checked={relatedToPrinter} onChange={() => setRelatedToPrinter(true)} />
                <label htmlFor="printer">{t('printer')}</label>
              </div>

              {relatedToPrinter && (
                <div className='extra-padding-left'>
                  <label htmlFor="printerModel">{t('select_printer_model')}</label>
                  <select id='printerModel'>
                    <option selected disabled>{t('select_item')}  </option>
                    <option>Ithaca</option>
                    <option>Epson</option>
                  </select>
                </div>
              )}

              <br />

              <label htmlFor="equipmentLocation">{t('equipment_location')}</label>
              <select id='equipmentLocation' required>
                <option selected disabled>{t('select_location')}</option>
                <option>Front Counter</option>
                <option>Drive Thru</option>
                <option>KVS</option>
              </select>

              <br /><br />

              <label htmlFor="equipmentDetails">{t('equipment_details')}</label>
              <input type="text" id="equipmentDetails" name="equipmentDetails" placeholder={t('equipment_details_placeholder')} required />

              <br /><br />

              <label htmlFor="attachment1"><span style={{ color: 'red', fontWeight: 'bold' }}>{t('required_photo_damaged')}</span></label>
              <input
                id="attachment1"
                name="attachment1"
                type="file"
                required
                accept=".png, .pdf, .heic"
                onChange={onAttachmentChange(1)}
              />
              <div style={{ marginTop: 4, marginLeft: 4, color: "#666", fontSize: 12 }}>
                {attachment1DisplayName
                  ? attachment1DisplayName
                  : "Waiting for file..."}
              </div>
   <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>

                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {file1State.isConverting || file1Validation.status === "loading" ? (
                      <>
                        <ClipLoader size={18} color="#000000" />
                        <span style={{ color: "#000" }}>
                          {file1State.isConverting ? "Converting file 1 " : "Validating file 1..."}
                        </span>
                      </>
                    ) : file1Validation.status === "success" ? (
                      <>
                        <BiSolidCheckCircle size={18} color="#2e7d32" />
                        <span style={{ color: "#2e7d32", fontWeight: 500 }}>File 1 OK</span>
                      </>
                    ) : file1Validation.status === "failure" ? (
                      <>
                        <BiSolidError size={18} color="#d32f2f" />
                        <span style={{ color: "#d32f2f", fontWeight: 500, whiteSpace: "pre-line" }}>
                          File 1: {file1Validation.message}
                        </span>
                      </>
                    ) : (
                      <span style={{ color: "#666" }}>Select file 1 to validate.</span>
                    )}
                  </div>

                 
                </div>


              <label htmlFor="attachment2"><span style={{ color: 'red', fontWeight: 'bold' }}>{t('required_photo_connector_type')}</span></label>
              <input
                id="attachment2"
                name="attachment2"
                type="file"
                required
                accept=".png, .pdf, .heic"
                onChange={onAttachmentChange(2)}
              />
              <div style={{ marginTop: 4, marginLeft: 4, color: "#666", fontSize: 12 }}>
                {attachment2DisplayName
                  ? attachment2DisplayName
                  : "Waiting for file..."}
              </div>



              <div
                style={{
                  marginTop: 4,
                  marginBottom: 8,
                  marginLeft: 4,
                  display: "flex",

                }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>

               

                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {file2State.isConverting || file2Validation.status === "loading" ? (
                      <>
                        <ClipLoader size={18} color="#000000" />
                        <span style={{ color: "#000" }}>
                          {file2State.isConverting ? "Converting file 2 " : "Validating file 2..."}
                        </span>
                      </>
                    ) : file2Validation.status === "success" ? (
                      <>
                        <BiSolidCheckCircle size={18} color="#2e7d32" />
                        <span style={{ color: "#2e7d32", fontWeight: 500 }}>File 2 OK</span>
                      </>
                    ) : file2Validation.status === "failure" ? (
                      <>
                        <BiSolidError size={18} color="#d32f2f" />
                        <span style={{ color: "#d32f2f", fontWeight: 500, whiteSpace: "pre-line" }}>
                          File 2: {file2Validation.message}
                        </span>
                      </>
                    ) : (
                      <span style={{ color: "#666" }}>Select file 2 to validate.</span>
                    )}
                  </div>
                </div>
              </div>
              <label htmlFor="info" className="required">{t('detailed_description_issue')}</label>
              <textarea id="info" name="info" rows={10} placeholder={t('detailed_description_placeholder')} required></textarea>

              <br /><br />

              <hr />
              <button
                disabled={
                  isSubmitting ||
                  file1State.isConverting ||
                  file2State.isConverting ||
                  file1Validation.status === "loading" ||
                  file2Validation.status === "loading"
                }
                className="red-button"
                type="submit"
              >
                <b>{t("submit_button")}</b>
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  )
}

export default NewCAP;